 <template>
  <div class="page-body" :class="{ 'teacher-login': isTeacherLogin }">
    <exam-header :canClickLogo="true" />
    <div class="page-body-container">
      <div class="page-body-main">
        <div class="page-body-main_right"></div>
        <div class="page-body-main_lionPic">
          <img src="@/common/images/qzCollege/top_img.png" alt="" />
        </div>
        <div class="page-body-main_login">
          <login-panel
              :loading="loading"
              :isTeacherLogin="isTeacherLogin"
              :accountError="accountError"
              @loginSuccess="onLoginSuccess"
              @clear="handleErrorClear"
              />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ExamHeader from '@/components/examHeader.vue';
import LoginPanel from '@/components/ursLoginPanel.vue';
import { getParamByName } from "@/common/js/util";
import { getCourseAuth, getUserInfo,createVisitor } from "@/api/user";
import { reportErrorEvent } from '@/common/js/track';

export default {
    components: {
      ExamHeader,
      LoginPanel
    },
    data() {
      return {
        ursInstance: null,
        isTeacherLogin: false,
        loading:false,
        accountError: '',
        pollingCount: 0,
      }
    },
    created() {
      this.checkRouteType();
      if(sessionStorage.getItem('loginSuccess')){
        getCourseAuth().then((res) => {
          if(res.body?.auth){
            localStorage.setItem('authHeader', res.body.auth);
            this.onLoginSuccess()
          }else{
            this.$message.error('登录失败，请尝试使用账号密码登录...')
          }
        }).finally(() => {
          sessionStorage.removeItem('loginSuccess');
        })
      }
    },
    methods: {
      onLoginSuccess() {
        this.loading = true
        // AUTH 生效存在延迟，轮询判断
        this.pollingCount = 0;
        this.checkLoginPolling();

      },
      checkRouteType() {
        this.isTeacherLogin = this.$route.path.includes('/teacher');
      },
      // 轮询判断登录是否成功
      checkLoginPolling() {
        setTimeout(() => {
          this.pollingCount++;
          getUserInfo()
            .then((res) => { // auth生效，接口200
              if (res?.body?.identity) { // 账号有权益
                this.goSuccessUrl()
              } else {
                createVisitor().then((res) => {
                }).finally(() => {
                  this.goSuccessUrl()
                })
                // this.accountError = '当前账号不存在';
                // this.loading = false;
                // this.$message.error('登录失败，当前账号不存在')
                // localStorage.removeItem('authHeader');
              }
            })
            .catch((error) => {
              reportErrorEvent({
                type: 'login_polling',
                error: error?.message || JSON.stringify(error),
                auth: localStorage.getItem('authHeader'),
              });
              if (this.pollingCount < 10) {
                this.checkLoginPolling();
              } else { // 轮询超过次数
                this.accountError = '登录失败，请稍后再试';
                this.loading = false;
                localStorage.removeItem('authHeader');
              }
            })
        }, 1500)
      },
      goSuccessUrl() {
        const redirect = getParamByName('redirect');
        if (redirect) {
          try {
            window.location.href = decodeURIComponent(redirect);
          } catch {
            window.location.href = '/';
          }
        } else {
          this.$router.push({ name: this.isTeacherLogin ? 'paperListTeacher' : 'home' });
        }
      },
      handleErrorClear() {
        this.accountError = '';
        this.loading = false;
      }
    },
  }
</script>
<style scoped lang="less">
.page-body{
  min-width: 1024px;
  padding-top: 72px;
  height: 100vh;
  min-height: 650px;
  overflow: hidden;
  box-sizing: border-box;
  background: #000000 url("@/common/images/qzCollege/top_bg.png") bottom right no-repeat;
  background-size: 42vw auto;
  &-container {
    height: 100%;
    width: 100%;
  }
  &-main {
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    &_right {
      //margin-left: 306px;
      width: 36vw;
      height: 100%;
      min-width: 500px;
      max-width: 692px;
      background: #E60012 url("@/common/images/qzCollege/login_student_bg.png") center no-repeat;
      background-size: 100% auto;
      display: flex;
      justify-content: center;
      flex-direction: column;
      padding: 0 3.5vw;
      box-sizing: border-box;
      .right_title{
        margin-top: 15vh;
        h1{
          font-size: clamp(36px, 3.75vw, 72px);
          color: #FFFFFF;
          font-weight: bold;
          text-align: left;
          line-height: 1.2;
        }
      }
      .right_info{
        margin-top: 32px;
        text-align: left;
        p{
          color: rgba(255, 255, 255, 0.7);
          &:first-child{
            font-size: 24px;
          }
          &:last-child{
            font-size: 14px;
            margin-top: 8px;
          }
        }
      }
    }
    &_lionPic{
      width: 398px;
      height: 427px;
      position: absolute;
      bottom: 0;
      right: 20px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    &_login {
      box-sizing: border-box;
      background: #FFFFFF;
      flex-shrink: 0;
      width: 480px;
      height: 436px;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 187px 0 0 82px;
      position: relative;
      z-index: 2;
      overflow: hidden;
    }
  }
  &-ft{
    padding: 50px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      height: 80px;
    }
  }
  &.teacher-login{
    .page-body-main_right{
      background: #BD9F68 url("@/common/images/qzCollege/login_teacher_bg.png") center / cover no-repeat;
    }
  }
}
@media screen and (max-width:1600px) {
  .page-body-main_login{
    margin: 100px 0 0 50px;
  }
}
</style>